import * as Yup from 'yup';
import { createPost } from '../../reducers/feed/feed.actions';
import i18n from 'i18next';
import { checkFileSize, getLaravelValidationErrors, isImage, isVideo, getFormat } from '../../helpers';
import { SINGLE_POST, ROOT, PROFILE } from '../../constants/routes';
import {
  NewDeleteIcon
} from '../../components/Icons';
import { useEffect } from 'react';

const formik = ({ dispatch, history }) => {
  const hideTypeError = () => {
    document.querySelector('.file-type-error').classList.add('hidden-pop')
  }
  
  return {
    initialValues: {
      body: '',
      public: true,
      price: 2,
      files: [],
    },
    validationSchema: Yup.object().shape({
      // body: Yup.string().trim().required(i18n.t('Text field is required')),
      price: Yup.number()
        .positive('Price must be a positive number')
        .test('price check if paid', i18n.t('Price is required'), function (value) {
          if (!this.parent.public) {
            return !isNaN(value) && !!value;
          }
          return true;
        }),
      files: Yup.array()
        .test('file-types', i18n.t("You can only upload either image/images or a video in one post."), files => {
          if (files.length > 1) {
            return files.map(file => getFormat(file.file.name)).every((curr, index, arr) =>
              curr === arr[0]
            );
          }
          return true;
        })
        .test('video-type', i18n.t('Only one video is able to upload'), files => {
          if (files.length > 1 && isVideo(files[0].file.name)) {
            return false;
          }
          return true;
        })

        .test('file-size', i18n.t("File shouldn't exceed 256mb"), files => {
          for (let i = 0; i < files.length; i++) {
            if (!checkFileSize(files[i].file)) {
              return false;
            }
          }
          return true;
        })
        .test('file-length', i18n.t('The maximum amount of photos should not exceed 10.'), files => {
          if (files.length > 10) {
            return false;
          }
          return true;
        })
        .test('file-format', i18n.t("File is not supported"), files => files.every(file => 
          isVideo(file.orig_src ? file.orig_src : file.file.name) ||
          isImage(file.orig_src ? file.orig_src : file.file.name))
        )
    }),

    onSubmit: (values, { setStatus, setSubmitting, resetForm }) => {
      dispatch(createPost({ ...values, public: values.public ? 1 : 0, files: values.files.map(el => el.file) }))
        .then(resp => {
          setSubmitting(false);
          history.push({ pathname: PROFILE, state: {postPage:true} });
        })
        .catch(errors => {
          console.log('Create post form errors', errors);
          setStatus({ errors: getLaravelValidationErrors(errors) });
          setSubmitting(false);
        });
    },
    
  };

};

export default formik;
